var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup17(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 61,
    height: 75,
    transform: "translate(-6 -8)",
    fill: "#152d79"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(5.93 8.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0.07 -0.173)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M241.069,166a1.069,1.069,0,1,0,1.069,1.069A1.07,1.07,0,0,0,241.069,166",
    transform: "translate(-214.817 -148.534)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M241.069,226a1.069,1.069,0,1,0,1.069,1.069A1.07,1.07,0,0,0,241.069,226",
    transform: "translate(-214.817 -202.118)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M101.069,452a1.069,1.069,0,1,0,1.069,1.069A1.07,1.07,0,0,0,101.069,452",
    transform: "translate(-89.787 -403.953)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M280,167.069a1.069,1.069,0,0,0,1.069,1.069H293.9a1.069,1.069,0,0,0,0-2.139H281.069A1.069,1.069,0,0,0,280,167.069",
    transform: "translate(-250.54 -148.534)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M293.9,226H281.069a1.069,1.069,0,1,0,0,2.139H293.9a1.069,1.069,0,0,0,0-2.139",
    transform: "translate(-250.54 -202.118)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M26.732,0H5.346A5.352,5.352,0,0,0,0,5.346V49.4a5.352,5.352,0,0,0,5.346,5.346H26.732A5.352,5.352,0,0,0,32.078,49.4V35.393l3.564-2.673H48.117a3.211,3.211,0,0,0,3.208-3.208V14.542a3.211,3.211,0,0,0-3.208-3.208H32.078V5.346A5.352,5.352,0,0,0,26.732,0M5.346,2.139H26.732a3.213,3.213,0,0,1,3.024,2.139H2.322A3.213,3.213,0,0,1,5.346,2.139m21.385,50.47H5.346A3.211,3.211,0,0,1,2.139,49.4V46.193h27.8V49.4a3.211,3.211,0,0,1-3.208,3.208M49.187,14.542v14.97a1.07,1.07,0,0,1-1.069,1.069H35.286a1.07,1.07,0,0,0-.642.214L27.8,35.928V31.65a1.069,1.069,0,0,0-1.069-1.069H22.455a1.07,1.07,0,0,1-1.069-1.069V14.542a1.07,1.07,0,0,1,1.069-1.069H48.117a1.07,1.07,0,0,1,1.069,1.069M22.455,11.334a3.211,3.211,0,0,0-3.208,3.208v14.97a3.211,3.211,0,0,0,3.208,3.208h3.208v5.346a1.069,1.069,0,0,0,1.711.855L29.94,37v7.057H2.139V6.416h27.8v4.919Z",
    transform: "translate(-0.48 -0.284)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M145.346,452h-4.277a1.069,1.069,0,1,0,0,2.138h4.277a1.069,1.069,0,1,0,0-2.138",
    transform: "translate(-125.51 -403.953)",
    fill: "#152d79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup17);
export default __webpack_public_path__ + "static/media/Group17.873eac5d88484dd065ad1c1bb5aeabc9.svg";
export { ForwardRef as ReactComponent };